/** The types of communication available to the House Communications route. */
export enum CommunicationType {
  /**
   * Executive Communications are written statements presented to Congress by
   * federal-level entities and other designated entities.
   */
  EC = 'ec',

  /**
   * Memorials are petitions (written statements or requests) presented to the
   * Congress by the legislature of a state or territory.
   */
  ML = 'ml',

  /**
   * Presidential Messages are written messages from the President presented to
   * the Congress.
   */
  PM = 'pm',

  /**
   * Petitions are written statements or requests from any entity.
   */
  PT = 'pt'
}
